import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconHistoryLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.98 20.5c-2.01 0-3.781-.613-5.314-1.84-1.534-1.227-2.517-2.797-2.949-4.71a.621.621 0 0 1 .098-.548.693.693 0 0 1 .503-.29.78.78 0 0 1 .55.12.845.845 0 0 1 .34.476c.38 1.545 1.2 2.813 2.46 3.804 1.26.992 2.697 1.488 4.313 1.488 1.95 0 3.604-.68 4.962-2.038 1.359-1.358 2.038-3.012 2.038-4.962 0-1.95-.68-3.604-2.038-4.963C15.585 5.68 13.931 5 11.981 5a6.683 6.683 0 0 0-3.071.728 7.557 7.557 0 0 0-2.468 2.003h1.866c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.39-.216.534a.725.725 0 0 1-.534.216H4.885a.874.874 0 0 1-.644-.26.874.874 0 0 1-.26-.644V4.904c0-.213.072-.39.216-.534a.726.726 0 0 1 .534-.216c.213 0 .39.072.535.216a.726.726 0 0 1 .215.534v1.619a8.487 8.487 0 0 1 2.915-2.23 8.368 8.368 0 0 1 3.585-.793c1.18 0 2.285.223 3.316.67a8.609 8.609 0 0 1 2.695 1.819 8.609 8.609 0 0 1 1.82 2.695A8.257 8.257 0 0 1 20.481 12c0 1.18-.223 2.285-.67 3.315a8.606 8.606 0 0 1-1.819 2.697 8.607 8.607 0 0 1-2.696 1.819 8.254 8.254 0 0 1-3.315.669Zm.78-8.804 2.75 2.75a.727.727 0 0 1 .212.522.706.706 0 0 1-.213.532.717.717 0 0 1-.526.217.718.718 0 0 1-.527-.217l-2.925-2.925a.905.905 0 0 1-.271-.648V7.75a.73.73 0 0 1 .215-.535A.727.727 0 0 1 12.01 7c.213 0 .39.072.534.215a.727.727 0 0 1 .215.535v3.946Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconHistoryLine;
